
<div class="container">
    <div class="main-header">
        <slot name="main-header" />
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        /*flex-wrap: wrap;*/
    }
    .main-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex: 1 1 100%;
        font-size: var(--font-size-page-header);
    }

</style>
